module.exports = __webpack_public_path__ + "img/ice4.a269eafa.png";